import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { NestApiProvider } from '../nest-api';
import { ResponseData } from '../nest-responses';

@Injectable()
export class SegmentApi {

  private service: string = '';
  private model: string = 'erp/segment';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public getSegmentDetail(payload: { segmentOpt: number}): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getSegmentDetail';
    const params: any = payload || {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public getSegment(payload: { orderNo: number}): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getSegment';
    const params: any = payload || {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/erp/segment.api.ts